/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as OrgIdRouteImport } from './routes/org/$id'
import { Route as InviteInvitationCodeRouteImport } from './routes/invite/$invitationCode'
import { Route as BookingEventIdRouteImport } from './routes/booking/$eventId'
import { Route as UserUserIdQuizRouteImport } from './routes/user/$userId/quiz'

const TermsLazyRouteImport = createFileRoute('/terms')()
const PrivacyLazyRouteImport = createFileRoute('/privacy')()
const AboutUsLazyRouteImport = createFileRoute('/about-us')()
const IndexLazyRouteImport = createFileRoute('/')()
const HomeIndexLazyRouteImport = createFileRoute('/home/')()
const EventIndexLazyRouteImport = createFileRoute('/event/')()
const EventIdLazyRouteImport = createFileRoute('/event/$id')()
const UserUserIdWalletLazyRouteImport = createFileRoute(
  '/user/$userId/wallet',
)()
const UserUserIdProfileLazyRouteImport = createFileRoute(
  '/user/$userId/profile',
)()
const UserUserIdBookingIndexLazyRouteImport = createFileRoute(
  '/user/$userId/booking/',
)()
const UserUserIdBookingBookingIdLazyRouteImport = createFileRoute(
  '/user/$userId/booking/$bookingId',
)()

const TermsLazyRoute = TermsLazyRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))
const PrivacyLazyRoute = PrivacyLazyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/privacy.lazy').then((d) => d.Route))
const AboutUsLazyRoute = AboutUsLazyRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about-us.lazy').then((d) => d.Route))
const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const HomeIndexLazyRoute = HomeIndexLazyRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/home/index.lazy').then((d) => d.Route))
const EventIndexLazyRoute = EventIndexLazyRouteImport.update({
  id: '/event/',
  path: '/event/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/event/index.lazy').then((d) => d.Route))
const EventIdLazyRoute = EventIdLazyRouteImport.update({
  id: '/event/$id',
  path: '/event/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/event/$id.lazy').then((d) => d.Route))
const OrgIdRoute = OrgIdRouteImport.update({
  id: '/org/$id',
  path: '/org/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInvitationCodeRoute = InviteInvitationCodeRouteImport.update({
  id: '/invite/$invitationCode',
  path: '/invite/$invitationCode',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingEventIdRoute = BookingEventIdRouteImport.update({
  id: '/booking/$eventId',
  path: '/booking/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdWalletLazyRoute = UserUserIdWalletLazyRouteImport.update({
  id: '/user/$userId/wallet',
  path: '/user/$userId/wallet',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/user/$userId/wallet.lazy').then((d) => d.Route),
)
const UserUserIdProfileLazyRoute = UserUserIdProfileLazyRouteImport.update({
  id: '/user/$userId/profile',
  path: '/user/$userId/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/user/$userId/profile.lazy').then((d) => d.Route),
)
const UserUserIdQuizRoute = UserUserIdQuizRouteImport.update({
  id: '/user/$userId/quiz',
  path: '/user/$userId/quiz',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdBookingIndexLazyRoute =
  UserUserIdBookingIndexLazyRouteImport.update({
    id: '/user/$userId/booking/',
    path: '/user/$userId/booking/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/user/$userId/booking/index.lazy').then((d) => d.Route),
  )
const UserUserIdBookingBookingIdLazyRoute =
  UserUserIdBookingBookingIdLazyRouteImport.update({
    id: '/user/$userId/booking/$bookingId',
    path: '/user/$userId/booking/$bookingId',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/user/$userId/booking/$bookingId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/test': typeof TestRoute
  '/about-us': typeof AboutUsLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/terms': typeof TermsLazyRoute
  '/booking/$eventId': typeof BookingEventIdRoute
  '/invite/$invitationCode': typeof InviteInvitationCodeRoute
  '/org/$id': typeof OrgIdRoute
  '/event/$id': typeof EventIdLazyRoute
  '/event': typeof EventIndexLazyRoute
  '/home': typeof HomeIndexLazyRoute
  '/user/$userId/quiz': typeof UserUserIdQuizRoute
  '/user/$userId/profile': typeof UserUserIdProfileLazyRoute
  '/user/$userId/wallet': typeof UserUserIdWalletLazyRoute
  '/user/$userId/booking/$bookingId': typeof UserUserIdBookingBookingIdLazyRoute
  '/user/$userId/booking': typeof UserUserIdBookingIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/test': typeof TestRoute
  '/about-us': typeof AboutUsLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/terms': typeof TermsLazyRoute
  '/booking/$eventId': typeof BookingEventIdRoute
  '/invite/$invitationCode': typeof InviteInvitationCodeRoute
  '/org/$id': typeof OrgIdRoute
  '/event/$id': typeof EventIdLazyRoute
  '/event': typeof EventIndexLazyRoute
  '/home': typeof HomeIndexLazyRoute
  '/user/$userId/quiz': typeof UserUserIdQuizRoute
  '/user/$userId/profile': typeof UserUserIdProfileLazyRoute
  '/user/$userId/wallet': typeof UserUserIdWalletLazyRoute
  '/user/$userId/booking/$bookingId': typeof UserUserIdBookingBookingIdLazyRoute
  '/user/$userId/booking': typeof UserUserIdBookingIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/test': typeof TestRoute
  '/about-us': typeof AboutUsLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/terms': typeof TermsLazyRoute
  '/booking/$eventId': typeof BookingEventIdRoute
  '/invite/$invitationCode': typeof InviteInvitationCodeRoute
  '/org/$id': typeof OrgIdRoute
  '/event/$id': typeof EventIdLazyRoute
  '/event/': typeof EventIndexLazyRoute
  '/home/': typeof HomeIndexLazyRoute
  '/user/$userId/quiz': typeof UserUserIdQuizRoute
  '/user/$userId/profile': typeof UserUserIdProfileLazyRoute
  '/user/$userId/wallet': typeof UserUserIdWalletLazyRoute
  '/user/$userId/booking/$bookingId': typeof UserUserIdBookingBookingIdLazyRoute
  '/user/$userId/booking/': typeof UserUserIdBookingIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/test'
    | '/about-us'
    | '/privacy'
    | '/terms'
    | '/booking/$eventId'
    | '/invite/$invitationCode'
    | '/org/$id'
    | '/event/$id'
    | '/event'
    | '/home'
    | '/user/$userId/quiz'
    | '/user/$userId/profile'
    | '/user/$userId/wallet'
    | '/user/$userId/booking/$bookingId'
    | '/user/$userId/booking'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/test'
    | '/about-us'
    | '/privacy'
    | '/terms'
    | '/booking/$eventId'
    | '/invite/$invitationCode'
    | '/org/$id'
    | '/event/$id'
    | '/event'
    | '/home'
    | '/user/$userId/quiz'
    | '/user/$userId/profile'
    | '/user/$userId/wallet'
    | '/user/$userId/booking/$bookingId'
    | '/user/$userId/booking'
  id:
    | '__root__'
    | '/'
    | '/test'
    | '/about-us'
    | '/privacy'
    | '/terms'
    | '/booking/$eventId'
    | '/invite/$invitationCode'
    | '/org/$id'
    | '/event/$id'
    | '/event/'
    | '/home/'
    | '/user/$userId/quiz'
    | '/user/$userId/profile'
    | '/user/$userId/wallet'
    | '/user/$userId/booking/$bookingId'
    | '/user/$userId/booking/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  TestRoute: typeof TestRoute
  AboutUsLazyRoute: typeof AboutUsLazyRoute
  PrivacyLazyRoute: typeof PrivacyLazyRoute
  TermsLazyRoute: typeof TermsLazyRoute
  BookingEventIdRoute: typeof BookingEventIdRoute
  InviteInvitationCodeRoute: typeof InviteInvitationCodeRoute
  OrgIdRoute: typeof OrgIdRoute
  EventIdLazyRoute: typeof EventIdLazyRoute
  EventIndexLazyRoute: typeof EventIndexLazyRoute
  HomeIndexLazyRoute: typeof HomeIndexLazyRoute
  UserUserIdQuizRoute: typeof UserUserIdQuizRoute
  UserUserIdProfileLazyRoute: typeof UserUserIdProfileLazyRoute
  UserUserIdWalletLazyRoute: typeof UserUserIdWalletLazyRoute
  UserUserIdBookingBookingIdLazyRoute: typeof UserUserIdBookingBookingIdLazyRoute
  UserUserIdBookingIndexLazyRoute: typeof UserUserIdBookingIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/': {
      id: '/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event/': {
      id: '/event/'
      path: '/event'
      fullPath: '/event'
      preLoaderRoute: typeof EventIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event/$id': {
      id: '/event/$id'
      path: '/event/$id'
      fullPath: '/event/$id'
      preLoaderRoute: typeof EventIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$id': {
      id: '/org/$id'
      path: '/org/$id'
      fullPath: '/org/$id'
      preLoaderRoute: typeof OrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$invitationCode': {
      id: '/invite/$invitationCode'
      path: '/invite/$invitationCode'
      fullPath: '/invite/$invitationCode'
      preLoaderRoute: typeof InviteInvitationCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$eventId': {
      id: '/booking/$eventId'
      path: '/booking/$eventId'
      fullPath: '/booking/$eventId'
      preLoaderRoute: typeof BookingEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId/wallet': {
      id: '/user/$userId/wallet'
      path: '/user/$userId/wallet'
      fullPath: '/user/$userId/wallet'
      preLoaderRoute: typeof UserUserIdWalletLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId/profile': {
      id: '/user/$userId/profile'
      path: '/user/$userId/profile'
      fullPath: '/user/$userId/profile'
      preLoaderRoute: typeof UserUserIdProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId/quiz': {
      id: '/user/$userId/quiz'
      path: '/user/$userId/quiz'
      fullPath: '/user/$userId/quiz'
      preLoaderRoute: typeof UserUserIdQuizRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId/booking/': {
      id: '/user/$userId/booking/'
      path: '/user/$userId/booking'
      fullPath: '/user/$userId/booking'
      preLoaderRoute: typeof UserUserIdBookingIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId/booking/$bookingId': {
      id: '/user/$userId/booking/$bookingId'
      path: '/user/$userId/booking/$bookingId'
      fullPath: '/user/$userId/booking/$bookingId'
      preLoaderRoute: typeof UserUserIdBookingBookingIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  TestRoute: TestRoute,
  AboutUsLazyRoute: AboutUsLazyRoute,
  PrivacyLazyRoute: PrivacyLazyRoute,
  TermsLazyRoute: TermsLazyRoute,
  BookingEventIdRoute: BookingEventIdRoute,
  InviteInvitationCodeRoute: InviteInvitationCodeRoute,
  OrgIdRoute: OrgIdRoute,
  EventIdLazyRoute: EventIdLazyRoute,
  EventIndexLazyRoute: EventIndexLazyRoute,
  HomeIndexLazyRoute: HomeIndexLazyRoute,
  UserUserIdQuizRoute: UserUserIdQuizRoute,
  UserUserIdProfileLazyRoute: UserUserIdProfileLazyRoute,
  UserUserIdWalletLazyRoute: UserUserIdWalletLazyRoute,
  UserUserIdBookingBookingIdLazyRoute: UserUserIdBookingBookingIdLazyRoute,
  UserUserIdBookingIndexLazyRoute: UserUserIdBookingIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
